<template>
    <div id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title">
                Edit Document
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark>fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container>
            <v-layout>
                <v-flex xs12>
                    <v-form>
                        <v-text-field
                        :error-messages="messages.title"
                        v-model="doc.title"
                        label="Document Title"
                        type="text"
                        filled
                        >
                        <template slot="append-outer">
                          <v-tooltip left>
                           <template v-slot:activator="{on}">
                            <v-icon v-on="on">fa fa-question</v-icon>
                           </template>
                           <span>Enter document title</span>
                          </v-tooltip>
                        </template>
                        </v-text-field>
                        <v-textarea
                        v-model="doc.description"
                        label="Description"
                        hint="Enter a description for this document"
                        filled
                        >
                        <template slot="append-outer">
                          <v-tooltip left>
                           <template v-slot:activator="{on}">
                            <v-icon v-on="on">fa fa-question</v-icon>
                           </template>
                           <span>Enter a description for this document</span>
                          </v-tooltip>
                        </template>
                        </v-textarea>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-container>
        <v-footer absolute height="68">
            <v-flex px-4 py-4 text-right>
                <v-btn v-if="loading" color="primary" loading></v-btn>
                <v-btn v-else color="primary" class="ml-2 add-course-button" @click="updateDocument">Update Document</v-btn>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import courseAPI from "@/api/course.js";

    export default {
        name: "EditDocument",
        props: {
            id: {
                type: String,
                default: null
            },
            index: {
                type: Number,
                default: null
            },
            item: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            doc: {},
            messages: {},
            loading: false,
            type: "document",
            successMessage: "Document Successfully Updated.",
            errorMessage: "Oops, something went wrong! Please check information is correct."
        }),
        mounted() {
            this.doc = this.item;
            this.doc.assetId = this.id;
        },
        methods: {
            closePanel() {
                this.$emit("closePanel", {});
            },
            updateDocument() {
                let index = this.index;
                this.loading = true;
                courseAPI
                .editDocument(
                    this.doc
                    )
                .then(resp => {
                    this.closePanel();
                    resp.data.data.index = index;
                    this.$store.dispatch("editCourseMaterials", resp.data.data);
                    this.$snotify.success(this.successMessage);
                    this.loading = false;
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                })
                .catch(err => {
                    this.$snotify.error(this.errorMessage);
                    this.messages = this.$gf.errorResponse(err);
                    this.loading = false;
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                });
            }
        }
    };
</script>
